import Vue from 'vue'
import axios from 'axios'
import { getToken, userLoginOut } from './auth'
import router from '../router'
import { baseUrl } from '@/common/env.js'

let vm = new Vue()
const ajax = axios.create({
	baseURL: baseUrl,
	timeout: 30000
})

/** 请求拦截器 **/
ajax.interceptors.request.use(
	config => {
		const token = getToken()
		if (token) {
			config.headers.Authorization = token
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

/** 响应拦截器 **/
ajax.interceptors.response.use(
	response => {
		if (response.data.code === -1) {
			vm.$message({
				message: '登录已过期,请重新登录',
				type: 'error'
			})
			userLoginOut()
			router.push({
				name: 'Login'
			})
			return
		}

		if (response.status === 200) {
			return Promise.resolve(response.data)
		} else {
			return Promise.reject(response.data.message)
		}
	},
	error => {
		return Promise.reject(error)
	}
)

/* 统一封装get请求 */
export const get = (url, params, config = {}) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'get',
			url,
			params,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

/* 统一封装post请求  */
export const post = (url, data, config = {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	}
}) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'post',
			url,
			data,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

/* 统一封装put请求  */
export const put = (url, data, config = {}) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'put',
			url,
			data,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

/* 统一封装delete请求  */
export const deletefn = (url, data, config = {}) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'delete',
			url,
			data,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

// 上传文件
export const upload = (url, data, config = {}) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'post',
			url,
			data,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

// 下载文件
export const downLoad = (url, data, config = { responseType: 'blob' }) => {
	return new Promise((resolve, reject) => {
		ajax({
			method: 'get',
			url,
			data,
			...config
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}
